import React, { useState } from 'react';
import { currentUserSelectors } from '@lifesize/nucleus';
import { hooks } from '@lifesize/clients.sdk';
import { injectIntl, defineMessages } from 'react-intl';
import clipboard from 'clipboard-js';
import { ReactComponent as PersonIcon } from '@lifesize/ux-assets/vectors/svgIcons/person.svg';
import { ReactComponent as ChevronDownIcon } from '@lifesize/ux-assets/vectors/svgIcons/chevron-down.svg';
import Dropdown from 'components/Dropdown/Dropdown';
import classes from './UserBadge.module.scss';
import { useSelector } from 'react-redux';

const messages = defineMessages({
  callMeLink: { id: 'components.userBadge.menu.label.callMeLink', defaultMessage: 'Call Me Link' },
  copied: { id: 'components.userBadge.notification.copied', defaultMessage: 'Copied' },
  copy: { id: 'components.userBadge.menu.link.copy', defaultMessage: 'Copy' },
  myExtension: { id: 'components.userBadge.menu.label.myExtension', defaultMessage: 'My Extension' }
});

let notificationTimer = 0;

export const UserBadge = (props) => {
  const [showCopiedNotification, setShowCopiedNotification] = useState(false);
  const { extension, name } = hooks.useUserInfo();
  const { doNotDisturb } = hooks.useSettings();
  const myInviteUrl = useSelector((state) => currentUserSelectors.myInfo(state).inviteURL);

  const buttonComponent = () => (
    <div className={classes.extension}>
      <div>{`${props.intl.formatMessage(messages.myExtension)}: ${extension}`}</div>
      <ChevronDownIcon data-testid="chevronDownIcon" className={classes.menuIcon} />
    </div>
  );

  const copyToClipboard = (textToCopy) => {
    clipboard.copy({
      'text/plain': textToCopy
    });
    clearTimeout(notificationTimer);
    setShowCopiedNotification(true);
    notificationTimer = setTimeout(() => {
      setShowCopiedNotification(false);
    }, 2000);
  };

  const renderNotification = () => {
    if (!showCopiedNotification) return null;
    return <div className={classes.notification}>{props.intl.formatMessage(messages.copied)}</div>;
  };

  const menuComponent = () => (
    <ul className={classes.menu}>
      <li onClick={() => copyToClipboard(myInviteUrl)} data-testid="headerCopyCallMeLink">
        <div className={classes.label}>
          <div className={classes.title}>{props.intl.formatMessage(messages.callMeLink)}</div>
          <div className={classes.value}>{myInviteUrl}</div>
        </div>
        <div className={classes.copyLink}>{props.intl.formatMessage(messages.copy)}</div>
      </li>
      <li onClick={() => copyToClipboard(extension)} data-testid="headerCopyExtension">
        <div className={classes.label}>
          <div>{props.intl.formatMessage(messages.myExtension)}</div>
          <div>{extension}</div>
        </div>
        <div className={classes.copyLink}>{props.intl.formatMessage(messages.copy)}</div>
      </li>
    </ul>
  );

  return (
    <div className={classes.container}>
      <div className={classes.avatar} data-testid="userBadge">
        <div className={classes.icon}>
          <PersonIcon data-testid="personIcon" />
        </div>
        <div className={classes[doNotDisturb ? 'dnd' : 'available']} />
      </div>
      <div className={classes.label}>
        <div>{name}</div>
        <Dropdown
          buttonComponent={buttonComponent()}
          containerClassName={classes.menuButton}
          dataTestId="headerExtensionDropdown"
          dropdownClassName={classes.dropdown}
          menuComponent={menuComponent()}
          menuNoLeft={true}
          menuNoTop={true}
          noCaret={true}
        />
        {renderNotification()}
      </div>
    </div>
  );
};

export default injectIntl(UserBadge);
